
const cvData = [
    { year: 2024, month: "September", desc: "“The Guy With All the Hats” SJA documentary, Tim Henkel, director" },
    { year: 2024, month: "July", desc: "Cartoonist/Columnist @ Toledo Free Press" },
    { year: 2023, month: "February", desc: "“Water Preservation T-Shirts,” designer" },
    { year: 2020, month: "March", desc: "“2020 and the Challenge to Create (Covid)” Online Show thru Flatlanders Gallery, Blissfield, MI" },
    { year: 2019, month: "Summer", desc: "Taught Middle school Art Maumee Valley Country Day School, Toledo" },
    { year: 2018, month: "Dec", desc: "“The Collective Experiment” @ The Carr Center, Detroit," },
    { year: 2017, month: "Dec", desc: "Release of “The Show” & “Hours Into Seasons” Books" },
    { year: 2017, month: "June", desc: "“Evan St. Jasthane’s Astounding Sideshow” one man show Hudson Gallery, Sylvania, Ohio" },
    { year: 2016, month: "Nov", desc: "“100 X 100, 100 Sculptors, 100 Sculptures” Ella Sharp Museum, Jackson, MI" },
    { year: 2013, month: "November", desc: "Release of “Random Commands” book, Aureole Press, Univ of Toledo" },
    { year: 2013, month: "Oct", desc: "“Thinking Outside the Box” @ Liberal Arts Gallery, Detroit" },
    { year: 2012, month: "October", desc: "Work on display at Intuit Center for Intuitive Art, Chicago" },
    { year: 2012, month: "August", desc: "“Outside Outsiders Art Show,” Judith Racht Gallery, Harbert, Michigan" },
    { year: 2011, month: "August", desc: "Toledo Area Artists’ Show, Toledo Museum of Art" },
    { year: 2011, month: "March", desc: "“West Palm Beach Juried Art Show,” WPB, Florida (placed 2nd)" },
    { year: 2010, month: "May", desc: "“Greatest Hits & Other Drivel” 1st One man show at Madhouse Gallery, Toledo, Ohio" },
    { year: 2009, month: "July", desc: "NOWOH Art Show, Dorothy Uber Bryan and Willard Wankelman Galleries, Bowling Green State University Bowling Green, Ohio" },
    { year: 2008, month: "September", desc: "Illustrations for “Our Colorful History - A Brief Look at the Beginning of Palm Beach County” coloring book for the Palm Beach County History Museum, West Palm Beach, Fl." },
    { year: 2007, month: "March", desc: "“Big Ten Art Show” Madhouse Productions, Toledo, O" },
    { year: 2006, month: "October", desc: "Pieces on display in Visionary Art Museum, Baltimore, Md." },
    { year: 2006, month: "June", desc: "“Drotar: The Work of the Slovakian Wire Artist,” Slovakian Embassy Washington, D.C." },
];

const Bio = () => {
    return (

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
                <img src="/sja.jpg" alt="SJA" className=" border-white border-2 rounded-lg mt-8" width="80%" />
                <div className="mt-4">
                    <h1 className="text-2xl font-bold">Steven Jay Athanas</h1>
                    <div className="text-gray-600 text-base mt-5">


                        <p className="mt-3 text-justify">
                            Athanas has been making art professionally for over 6 decades. He has self-published several books of his drawings and “pomes” (his term). His work
                            has shown in Detroit, Cleveland, Ann Arbor, Blissfield, West Palm Beach, Colorado, Washington D.C., New York City and Toledo. He received his BA in
                            ArtEd from the University of Toledo. He has also released multiple recordings of his original songs.
                        </p>

                        <p className="mt-3 text-justify">
                            Athanas works in both 2D and 3D. His 3D work utilizes reimagined and found items, such as rusty wire and objects from Nature, as well as tissue
                            paper, clay and whatever else he can get his hands on. He has long been making mobiles and other sculptures using these materials, attaching them
                            to wire armatures to make fish, birds, human, and abstract forms.
                            They are usually painted on with acrylic paints and coated with non-flammable polyurethane for strength
                        </p>

                        <p className="mt-3 text-justify">
                            His 2D works are fantastical, whimsical works, more often than not with the aforementioned “pomes” and accompanying watercolor paintings.
                        </p>

                        {/* <p className="mt-3 text-justify">
He is currently working on a book of these 2D pieces through University Press, scheduled to be released in the Spring of 2024.    
</p> */}


                    </div>
                </div>

                <div className="mt-20 w-full md:col-span-2">
                    <h2 className="text-3xl font-bold mb-8 text-gray-900 border-b pb-4">STEVEN J ATHANAS CV (ABBREVIATED)</h2>
                    <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                        <table className="min-w-full divide-y divide-gray-300">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Year</th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Month</th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Event</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 bg-white">
                                {cvData.map((item, index) => (
                                    <tr key={index} className="hover:bg-gray-50">
                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-bold text-gray-900 sm:pl-6">{item.year}</td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{item.month}</td>
                                        <td className="px-3 py-4 text-sm text-gray-700">{item.desc}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Bio;